import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@ngneat/reactive-forms';
import { MultiSelectBlockPayload } from '../../types/multi-select-block-payload.interface';
import { BlockComponent } from '../block/block.component';
import { FormControlHintDirective } from '../../../form-control/directives/form-control-hint.directive';
import { MultiAutocompleteOptionDirective } from '../../../multi-autocomplete/multi-autocomplete-option.directive';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormControlInputDirective } from '../../../form-control/directives/form-control-input.directive';
import { MultiAutocompleteComponent } from '../../../multi-autocomplete/multi-autocomplete.component';
import { FormControlLabelDirective } from '../../../form-control/directives/form-control-label.directive';
import { FormControlComponent } from '../../../form-control/components/form-control/form-control.component';

@Component({
  selector: 'app-multi-select-block',
  templateUrl: './multi-select-block.component.html',
  styleUrls: ['./multi-select-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    FormControlComponent,
    FormControlLabelDirective,
    MultiAutocompleteComponent,
    FormControlInputDirective,
    FormsModule,
    ReactiveFormsModule,
    NgFor,
    MultiAutocompleteOptionDirective,
    NgIf,
    FormControlHintDirective,
  ],
})
export class MultiSelectBlockComponent extends BlockComponent<MultiSelectBlockPayload, undefined> implements OnInit {
  public readonly formControl = new FormControl();

  public ngOnInit(): void {
    this.register.next(this.formControl);
  }
}
